import type {
  WeeklyCashFlowDTO,
  WeeklyCashFlowWeekDTO,
  WeeklyCashFlowInsightDTO,
} from "../models/weeklyCashFlowDto";
import type {
  WeeklyCashFlowEntity,
  WeeklyCashFlowWeekEntity,
  WeeklyCashFlowInsightEntity,
} from "../../domain/entities/WeeklyCashFlowEntity";

function weekDtoToEntity(dto: WeeklyCashFlowWeekDTO): WeeklyCashFlowWeekEntity {
  return {
    label: dto.label,
    startDate: dto.startDate,
    endDate: dto.endDate,
    cashIn: dto.cashIn ?? 0,
    cashOut: dto.cashOut ?? 0,
  };
}

function insightDtoToEntity(
  dto: WeeklyCashFlowInsightDTO,
): WeeklyCashFlowInsightEntity {
  const accent = dto.accent ?? "brand";
  return {
    accent: accent === "error" || accent === "success" ? accent : "brand",
    label: dto.label ?? "",
    title: dto.title ?? "",
    description: dto.description ?? "",
  };
}

const defaultInsight: WeeklyCashFlowInsightEntity = {
  accent: "brand",
  label: "",
  title: "",
  description: "",
};

/**
 * Maps Weekly Cash Flow API response to domain entity.
 * Insights order: currentWeek, pattern, cashPosition (for panel display).
 */
export function weeklyCashFlowDtoToEntity(
  dto: WeeklyCashFlowDTO,
): WeeklyCashFlowEntity {
  const weeks = (dto.weeks ?? []).map(weekDtoToEntity);
  const ins = dto.insights;
  const insights: WeeklyCashFlowInsightEntity[] = [
    ins?.currentWeek,
    ins?.pattern,
    ins?.cashPosition,
  ].map((i) => (i ? insightDtoToEntity(i) : { ...defaultInsight }));

  return {
    monthLabel: dto.monthLabel ?? "",
    mtdNet: dto.mtdNet ?? "",
    weeks,
    insights,
  };
}
